export const getBrickSpaceTypes = async (id) => {
    var Airtable = require('airtable');
    var base = new Airtable({apiKey: 'patCIEwoxkUzvEYn5.50de4bf9db9e737be83adc1099d3a3a4763f93dd327599a3504596a0e3e933fe'}).base('app7kfG35eQYRupcU');

    let types = []
    base('brick_space_type_dim').select({
        // Selecting the first 3 records in Grid view:
        maxRecords: 5000,
        view: "Sorted"
    }).eachPage((records, fetchNextPage) => {		
        records.forEach(function(record) {
            types.push({
                "brick_space_type": record["fields"]["brick_space_type"],
                "name": record["fields"]["brick_space_type_name"],
                "description": record["fields"]["brick_space_type_description"],
                "parent": (record["fields"]["brick_space_type_parent_name"] && record["fields"]["brick_space_type_parent_name"][0]) || "Room",
            })
        });

        fetchNextPage();
    });
    types.sort((a, b) => a.parent.localeCompare(b.parent) || a.brick_space_type.localeCompare(b.brick_space_type))
    return types;
  };

  export const getPNNLSpaceTypes = async (id) => {
    var Airtable = require('airtable');
    var base = new Airtable({apiKey: 'patCIEwoxkUzvEYn5.50de4bf9db9e737be83adc1099d3a3a4763f93dd327599a3504596a0e3e933fe'}).base('app7kfG35eQYRupcU');

    let types = []
    base('pnnl_space_type_dim').select({
        // Selecting the first 3 records in Grid view:
        maxRecords: 5000,
    }).eachPage((records, fetchNextPage) => {		
        records.forEach(function(record) {
            types.push({
                "pnnl_space_type": record["fields"]["pnnl_space_type"],
                "name": record["fields"]["pnnl_space_type_name"],
                "description": record["fields"]["description"],
            })
        });

        fetchNextPage();
    });
    return types;
  };

  export const getBrickZoneTypes = async () => {
    var Airtable = require('airtable');
    var base = new Airtable({apiKey: 'patCIEwoxkUzvEYn5.50de4bf9db9e737be83adc1099d3a3a4763f93dd327599a3504596a0e3e933fe'}).base('app7kfG35eQYRupcU');

    let types = []
    base('brick_zone_dim').select({
        // Selecting the first 3 records in Grid view:
        maxRecords: 5000,
    }).eachPage((records, fetchNextPage) => {		
        records.forEach(function(record) {
            types.push({
                "brick_zone_type": record["fields"]["brick_zone_type"],
                "name": record["fields"]["brick_zone_name"],
                "description": record["fields"]["brick_zone_desc"],
            })
        });

        fetchNextPage();
    });
    return types;
  };

  export const getPNNLZoneTypes = async (id) => {
    var Airtable = require('airtable');
    var base = new Airtable({apiKey: 'patCIEwoxkUzvEYn5.50de4bf9db9e737be83adc1099d3a3a4763f93dd327599a3504596a0e3e933fe'}).base('app7kfG35eQYRupcU');

    let types = []
    base('pnnl_zone_dim').select({
        // Selecting the first 3 records in Grid view:
        maxRecords: 5000,
    }).eachPage((records, fetchNextPage) => {		
        records.forEach(function(record) {
            types.push({
                "name": record["fields"]["pnnl_zone_name"],
            })
        });

        fetchNextPage();
    });
    return types;
  };

  export const getBrickEquipmentTypes = async (id) => {
    var Airtable = require('airtable');
    var base = new Airtable({apiKey: 'patCIEwoxkUzvEYn5.50de4bf9db9e737be83adc1099d3a3a4763f93dd327599a3504596a0e3e933fe'}).base('app7kfG35eQYRupcU');

    let types = []
    base('brick_equipment_type_dim').select({
        // Selecting the first 3 records in Grid view:
        maxRecords: 5000,
        view: 'Sorted'
    }).eachPage((records, fetchNextPage) => {		
        records.forEach(function(record) {
            types.push({
                "brick_equipment_type": record["fields"]["brick_equipment_type"],
                "name": record["fields"]["brick_equipment_type_name"],
                "description": record["fields"]["brick_equipment_type_description"],
                "parent": (record["fields"]["brick_equipment_type_parent_name"]) || "General",
            })
        });

        fetchNextPage();
    });
    return types;
  };


  
  export const getEquipmentSystems = async () => {

    var Airtable = require('airtable');
    var base = new Airtable({apiKey: 'patCIEwoxkUzvEYn5.50de4bf9db9e737be83adc1099d3a3a4763f93dd327599a3504596a0e3e933fe'}).base('app7kfG35eQYRupcU');

    let systems = []
    base('brick_system_type_dim').select({
        // Selecting the first 3 records in Grid view:
        maxRecords: 5000,
        view: "Sorted"
    }).eachPage((records, fetchNextPage) => {		
        records.forEach(function(record) {
            systems.push({
                "brick_system_type": record["fields"]["brick_system_type"],
                "name": record["fields"]["brick_system_type_name"],
                "description": record["fields"]["brick_system_type_description"],
                "parent": (record["fields"]["brick_system_type_parent_name"] && record["fields"]["brick_system_type_parent_name"][0]) || "General",
            })
        });
    });
    return systems;

  };

  export const getBrickPointTypes = async () => {
    var Airtable = require('airtable');
    var base = new Airtable({apiKey: 'patCIEwoxkUzvEYn5.50de4bf9db9e737be83adc1099d3a3a4763f93dd327599a3504596a0e3e933fe'}).base('app7kfG35eQYRupcU');
    let types = []
    await base('brick_point_type_dim').select({
        // Selecting the first 3 records in Grid view:
        maxRecords: 5000,
        view: "Sorted"
    }).eachPage((records, fetchNextPage) => {		
        records.forEach(function(record) {
            types.push({
                "brick_point_type": record["fields"]["brick_point_type"],
                "name": record["fields"]["brick_point_type_name"],
                "description": record["fields"]["brick_point_type_description"],
                "parent": record["fields"]["brick_point_type_parent_name"],
            })
        });

        fetchNextPage();
    });
    return types;
  };
  

  export const getFeatureTypes = async () => {
    var Airtable = require('airtable');
    var base = new Airtable({apiKey: 'patCIEwoxkUzvEYn5.50de4bf9db9e737be83adc1099d3a3a4763f93dd327599a3504596a0e3e933fe'}).base('app7kfG35eQYRupcU');

    let types = []
    base('feature_type_dim').select({
        // Selecting the first 3 records in Grid view:
        maxRecords: 5000,
    }).eachPage((records, fetchNextPage) => {		
        records.forEach(function(record) {
            types.push({
                "feature_type": record["fields"]["feature_type"],
                "name": record["fields"]["feature_type_name"],
            })
        });
    });

    return types;
  };

  export const getAllProtocols = async () => {
    var Airtable = require('airtable');
    var base = new Airtable({apiKey: 'patCIEwoxkUzvEYn5.50de4bf9db9e737be83adc1099d3a3a4763f93dd327599a3504596a0e3e933fe'}).base('app7kfG35eQYRupcU');

    let types = []
    base('protocol_dim').select({
        // Selecting the first 3 records in Grid view:
        maxRecords: 5000,
    }).eachPage((records, fetchNextPage) => {		
        records.forEach(function(record) {
            types.push(record["fields"]["protocol_name"])
        });
    });

    return types;
  };

  export const getAllPhysicalConnectionTypes = async () => {
    var Airtable = require('airtable');
    var base = new Airtable({apiKey: 'patCIEwoxkUzvEYn5.50de4bf9db9e737be83adc1099d3a3a4763f93dd327599a3504596a0e3e933fe'}).base('app7kfG35eQYRupcU');

    let types = []
    base('physical_connectivity_dim').select({
        // Selecting the first 3 records in Grid view:
        maxRecords: 5000,
    }).eachPage((records, fetchNextPage) => {		
        records.forEach(function(record) {
            types.push(record["fields"]["physical_connectivity_name"])
        });
    });

    return types;
  };

  export const getAllUnits = async () => {
    var Airtable = require('airtable');
    var base = new Airtable({apiKey: 'patCIEwoxkUzvEYn5.50de4bf9db9e737be83adc1099d3a3a4763f93dd327599a3504596a0e3e933fe'}).base('app7kfG35eQYRupcU');

    let units = []
    await base('unit_dim').select({
        // Selecting the first 3 records in Grid view:
        maxRecords: 5000,
    }).eachPage((records, fetchNextPage) => {		
        records.forEach(function(record) {
            units.push({
                "brick_unit": record["fields"]["brick_unit"],
                "name": record["fields"]["unit_name"],
            })
        });

        fetchNextPage();
    });

    return units;
  };


  export const getAllUtilities = async () => {
    var Airtable = require('airtable');
    var base = new Airtable({apiKey: 'patCIEwoxkUzvEYn5.50de4bf9db9e737be83adc1099d3a3a4763f93dd327599a3504596a0e3e933fe'}).base('app3iO6COcyP8sQpR');
    
    let utilities = [];
    await base('utility_dim').select({
        // Selecting the first 3 records in Grid view:
        maxRecords: 5000,
        view: "Grid view"
    }).eachPage((records, fetchNextPage) => {		
        records.forEach(function(record) {
            let state = record.get('state')
            let utility = {
                id: record.get('utility_id'),
                abbr: record.get('utility_abbr'),
                name: record.get('utility_name'),
                decorated_name: state + " - " + record.get('utility_name')
            };

            utilities.push(utility);
        });

        fetchNextPage();
    
    })
    utilities.sort((a, b) => a.name.localeCompare(b.decorated_name))
    return utilities
  }